<template>
    <main class="moreabout">
    
      <div class="aboutLocalHead">

        <div class="photo" ref="exTarget" >
          <img src="../assets/profile3.png" alt="photo" />
          <img src="../assets/profile2.jpg" alt="photo" />
          <img src="../assets/profile.jpg" alt="photo" />
        </div>

        <div class="desc">
          <h1 id="pTop">Félix Natanael Abad</h1>
          <p :style="{ marginBottom: '20px'}">Systems and Computing engineer focused on Software Development.</p>
          
          <div class="icon-holder" >
            <div class="icon">
              <p :style="{ marginBottom: '10px'}"><i class="icofont-location-pin"></i>From Santo Domingo, Dominican Republic</p>
            </div>
          </div>

          <div class="icon-holder">
            <div class="icon">
              <p><i class="icofont-clock-time"></i>{{calcMyAge()}} years old</p>
            </div>
          </div>

        </div>
      </div>

      <div class="macontainer" id="meshMe">
        <About />
      </div>
    </main>
  </template>
  
<script>
  
  import About from '../components/About.vue';

  import queryPalette from "../mixins/themeColor.js";
  
  export default {
    name: "about",
    title: "About - Nethanzêl's Showroom",
    components: {
      About
    },

    mounted() {
      queryPalette.generatePalette().then((Palette) => {
        document.querySelector("#meshMe").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#meshMe").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
        document.querySelector("#meshMe").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
      });
      this.imageExchange();
    },

    data() {
      return {
        slideInterval: null
      }
    },

    beforeDestroy() {
      clearInterval(this.slideInterval);
    },

    methods: {
      calcMyAge() {
        let birthDate = new Date("1996/05/22");
        let today = new Date();
        if(today.getMonth() > birthDate.getMonth()) {
          return Number(today.getFullYear()) - Number(birthDate.getFullYear());
        } else {
          return (Number(today.getFullYear()) - Number(birthDate.getFullYear())) -1;
        }
      },
      imageExchange() {
        let container = this.$refs.exTarget;
        let imgCollection = container.getElementsByTagName("img");
        
        let index = 0;
        let beforeIndex = 0;

        for(let image of imgCollection) {
          if(index == 0) {
            index = 1; 
            continue;
          }
          image.style.display = "none";
        }

        this.slideInterval = setInterval(() => {
          
          imgCollection[index].style.display = "block";

          if(beforeIndex != undefined) imgCollection[beforeIndex].style.display = "none";

          beforeIndex = index;
          index = index+1;

          if(index > imgCollection.length -1) index = 0;
        }, 3500);
      }
    }
  };
</script>
  
<style scoped lang="scss">

  @media (prefers-color-scheme: dark) {
    .macontainer {
      background-color: #fff;
    }
    .aboutLocalHead {
      .desc {
        h1 {
          color: #fff;
        }

        p {
          color: #fff;
        }
      }
    }

    h1::after {
      border-bottom: 2px solid #fff;
    }
  }

  @media (prefers-color-scheme: light) {
    .macontainer {
      background-color: #d1d1d1;
    }

    .aboutLocalHead {
      .desc {
        h1 {
          color: #000;
        }

        p {
          color: #000;
        }
      }
    }

    h1::after {
      border-bottom: 2px solid #000;
    }

  }

  .moreabout {
    display: flex;
    flex-direction: column;
    cursor: default;
    max-width: 1366px;
    margin: 0 auto 0 auto;
    padding-top: 60px;
    color: #fff;
  }
  
  .macontainer {
    min-height: 45vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
    background-color: #d1d1d1;

    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;

    color: #000;
  }
  
  .aboutLocalHead {
    display: flex;
    margin: 35px auto;
    .photo {
      margin: 0 15px 0 0;
      img {
        border-radius: 50%;
        object-fit: contain;
        background-color: #fff;
        width: 280px;
        height: 280px;
        align-self: center;
        animation: showImage .5s linear;
      }
    }
    .desc {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: flex-start;

      h1 {
        font-weight: bolder;
        transition: .4s;
      }

      p {
        margin: 5px 35px;
        transition: .4s;
        i {
          margin: 0 10px 0 0;
          font-size: 20px;
        }
      }
    }
  }

  h1 {
    letter-spacing: 3px;
    text-align: center;
    width: 100%;
    cursor: default;
    z-index: 10;
    margin-bottom: 5px;
  }

  h1::after {
    content: "";
    display: block;
    margin: 0 auto;
    width: 300px;
  }

  
  h2 {
    font-size: 35px;
    letter-spacing: 2px;
    cursor: default;
  }

  @keyframes showImage {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @media screen and (max-width: 900px) {
    .aboutLocalHead {
      flex-direction: column;
      .photo {
        margin: 0 auto 10px auto;
      }
      .desc {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
      }
    }
  }
  
  @media screen and (max-width: 660px) {
    h2 {
      font-size: 30px;
      letter-spacing: 2px;
    }
  }
  
  @media screen and (max-width: 570px) {
  
    h2 {
      font-size: 25px;
      letter-spacing: 2px;
    }
  }
  
  @media screen and (max-width: 510px) {
    h1 {
      font-size: 40px;
      letter-spacing: 3px;
    }

    h1::after {
      margin-top: 10px;
      margin-bottom: 15px;
    }
  
    h2 {
      font-size: 20px;
      letter-spacing: 2px;
    }

    .aboutLocalHead {
      .desc {

        p {
          font-size: 16px;
          margin: 0 15px;
          i {
            font-size: 18px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 415px) {
    h1{
      font-size: 37px;
      letter-spacing: 2px;
    }
  }

  @media screen and (max-width: 415px) {
    h1{
      font-size: 35px;
      letter-spacing: 2px;
    }
  }

</style>
  